
export type ErrorSeverity = 'info' | 'warning' | 'error' | 'critical';

export interface AppError extends Error {
  severity: ErrorSeverity;
  context?: Record<string, unknown>;
  timestamp: Date;
}

export class ApplicationError extends Error implements AppError {
  severity: ErrorSeverity;
  context?: Record<string, unknown>;
  timestamp: Date;

  constructor(
    message: string, 
    severity: ErrorSeverity = 'error',
    context?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'ApplicationError';
    this.severity = severity;
    this.context = context;
    this.timestamp = new Date();
  }
}
